import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
}
export const Container: React.FC<ContainerProps> = ({ children }) => {
  const shadowLevel = useBreakpointValue({ base: 'none', sm: 1 });

  return (
    <Shadow level={shadowLevel} borderTopRadius={BoxRadius.sm} flex={1}>
      <VStack space={Spacing['stack.xxxs']}>{children}</VStack>
    </Shadow>
  );
};
